import {
  GROUPS_LIST,
  GROUPS_LIST_SUCCESS,
  GROUPS_LIST_ERROR,
  GROUPS_NEW,
  GROUPS_NEW_SUCCESS,
  GROUPS_NEW_ERROR,
  GROUPS_EDIT,
  GROUPS_DELETE,
  GROUPS_DELETE_SUCCESS,
  GROUPS_DELETE_ERROR,
} from "./actionTypes"


export const groupsList = data => ({
  type: GROUPS_LIST,
  payload: data
});

export const groupsListSuccess = data => ({
  type: GROUPS_LIST_SUCCESS,
  payload: {data}
});

export const groupsListError = error => ({
  type: GROUPS_LIST_ERROR,
  payload: error,
});

export const groupsNew = data => ({
  type: GROUPS_NEW,
  payload: data
});

export const groupsNewSuccess = data => ({
  type: GROUPS_NEW_SUCCESS,
  payload: {data}
});

export const groupsNewError = error => ({
  type: GROUPS_NEW_ERROR,
  payload: error,
});

export const groupsEdit = data => ({
  type: GROUPS_EDIT,
  payload: data
});

export const groupsDelete = data => ({
  type: GROUPS_DELETE,
  payload: data
});

export const groupsDeleteSuccess = data => ({
  type: GROUPS_DELETE_SUCCESS,
  payload: {data}
});

export const groupsDeleteError = error => ({
  type: GROUPS_DELETE_ERROR,
  payload: error,
});
